import { Box, Typography } from '@drone-js/core';
import TextSearchResultItem, { TextSearchItemWithCategories } from 'component/common/TextSearch/TextSearchResult/TextSearchResultItem';

import { CmsValue } from 'core/type/BootstrapConfig.types';
import ContentArea from 'component/common/ContentArea/ContentArea';
import React from 'react';
import { ScreenSize } from 'store/slice/screen';
import { SuggestionResult } from 'core/type/SuggestionResult.types';
import { TextSearchType } from 'core/type/TextSearch.types';
import { selectFeatureBehaviorFromBootstrap } from 'store/slice/bootstrap';
import { useSelector } from 'react-redux';

interface Props {
    results: SuggestionResult[];
    onSelect: (result: SuggestionResult) => void;
    cms: CmsValue;
    isInCitySearch: boolean;
    isSearchBoxFeatureGroup: boolean;
    screenSize: ScreenSize;
    searchText?: string;
}

const TextSearchResultItems: React.FC<Props> = (props) => {
    const isSearchBoxFeatureGroup = props.isSearchBoxFeatureGroup;
    const isTextSearchPopOver = useSelector(selectFeatureBehaviorFromBootstrap).SearchBoxPopOverFeature;
    const isNearByEnabled = useSelector(selectFeatureBehaviorFromBootstrap).SearchBoxNearMeFeature;
    const isGlobalKeywordSearch = useSelector(selectFeatureBehaviorFromBootstrap).GlobalKeywordSearch;
    const isSeachByCategories = useSelector(selectFeatureBehaviorFromBootstrap).SearchByCategories;
    const isDesktop = props.screenSize.desktop;
    const isMobile = props.screenSize.mobile;

    if (!props.results || props.results.length === 0) {
        return null;
    }

    // NO_TEXT_SEARCH_SCROLL: Limit search results to avoid showing scrollbar in the popover
    let results = [];
    if (isTextSearchPopOver || isGlobalKeywordSearch) {
        const maxResults = isGlobalKeywordSearch && !isMobile ? 6 : 8;
        results = props.results.slice(0, maxResults);
    } else {
        results = props.results;
    }

    const isNewDesignExps = isTextSearchPopOver || isSearchBoxFeatureGroup || isNearByEnabled;
    const oldHeader = !isTextSearchPopOver && !isSearchBoxFeatureGroup && '16';
    const headerPadding = isDesktop ? (isTextSearchPopOver ? '12' : '16') : isSearchBoxFeatureGroup ? '24' : '16';
    const paddingX = isSearchBoxFeatureGroup && isDesktop ? '0' : isNewDesignExps ? (isMobile ? '8' : '4') : '0';
    return (
        <ContentArea
            p={props.isInCitySearch || (isSearchBoxFeatureGroup && isDesktop) ? '0' : '4'}
            pt={isSearchBoxFeatureGroup ? '0' : '8'}
            data-testid="activities-overlay-text-search-result-list"
            mx="auto"
            width="100%"
            pb={isGlobalKeywordSearch ? '0' : '16'}
            role="list"
        >
            {props.isInCitySearch && (
                <Typography mx={oldHeader || headerPadding} py="12" variant="body-default-strong">
                    {props.cms[316884]}
                </Typography>
            )}
            <Box mx={isNewDesignExps ? '4' : '0'} my={isSearchBoxFeatureGroup && !isGlobalKeywordSearch ? '4' : '0'}>
                {results.map((result: SuggestionResult, index: number) => {
                    const isFirstResultWithCategories = index === results.findIndex((r) => r?.topCategories && r.topCategories.length > 0);
                    const shouldRenderCategories = result?.topCategories?.length && result.type === TextSearchType.City && isSeachByCategories && isFirstResultWithCategories;

                    return (
                        <Box key={result.id} px={paddingX}>
                            {shouldRenderCategories ? (
                                <TextSearchItemWithCategories
                                    cms={props.cms}
                                    searchText={props.searchText}
                                    result={result}
                                    onSelect={props.onSelect}
                                    isSearchBoxFeatureGroup={isSearchBoxFeatureGroup}
                                />
                            ) : (
                                <TextSearchResultItem searchText={props.searchText} result={result} onSelect={props.onSelect} isSearchBoxFeatureGroup={isSearchBoxFeatureGroup} />
                            )}
                        </Box>
                    );
                })}
            </Box>
        </ContentArea>
    );
};
TextSearchResultItems.displayName = 'TextSearchResultItems';

export default TextSearchResultItems;
